import { Component, IComponentOptions, bind } from "@eusoft/webapp-core";
import { Class, forModel } from "@eusoft/webapp-jsx";

import "./ToolbarButton.scss";
import { ContextMenu } from "@eusoft/webapp-ui/components/ContextMenu";
import { MaterialIcon } from "@eusoft/webapp-ui/components/Icon";
import { ViewNode } from "@eusoft/webapp-ui/types";

export interface IButtonOption<TValue> {
    value: TValue;
    text: string;
}

export interface IToolbarButtonOptions<TValue = unknown> extends IComponentOptions {

    type: "toggle" | "push" | "drop-down";

    items?: IButtonOption<TValue>[];

    value?: TValue;

    disabled?: boolean;

    showValue?: boolean;

    checked?: boolean;

    onCheckedChanged?: (value: boolean) => void;

    onValueChanged?: (value: TValue) => void;

    executeAsync?: () => Promise<void> | void;

    content: (value: TValue, checked?: boolean) => ViewNode;
}

export class ToolbarButton<TValue = unknown> extends Component<IToolbarButtonOptions> {
    constructor(options: IToolbarButtonOptions<TValue>) {
        super();

        this.init(ToolbarButton, {
            template: forModel<this>(m => <>
                <button on-click={(s, e) => m.onClick(e)} visible={m.visible} disabled={m.disabled} className={m.className}>
                    <Class name={m.type} />
                    <Class name="active" condition={m.active} />
                    <Class name="on" condition={m.type == "toggle" && m.checked} />
                    <Class name="off" condition={m.type == "toggle" && !m.checked} />
                    {m.content(m.value, m.checked)}
                    {m.showValue && m.value !== undefined && <span>{this.getValueText(m.value)}</span>}
                    {m.items && <span on-click={(s, e) => m.onDropDownClick(e)} className="options"><MaterialIcon name="arrow_drop_down" /></span>}
                </button>
                {m.items && <ContextMenu ref={m.menu}>
                    <ul className="drop-down-options">{m.items.forEach(a => <li on-click={() => m.value = a.value}>
                        {a.value == m.value ? <MaterialIcon name="check" /> : <span />}
                        {a.text}
                    </li>)}
                    </ul>
                </ContextMenu>}
            </>),
            ...options
        });


        this.onChanged("checked", v => this.onCheckedChanged(v));

        this.onChanged("value", v => this.onValueChanged(v));
    }

    protected onDropDownClick(ev: MouseEvent) {

        this.menu.show();

        ev.stopPropagation();
        ev.stopImmediatePropagation();
    }

    protected async onClick(ev: MouseEvent) {
        if (this.type == "toggle") {
            this.checked = !this.checked;
        }
        else if (this.type == "drop-down") {
            this.menu.show();
        }
        else {
            await this.executeAsync();
        }
    }

    @bind("action")
    onCheckedChanged?(value: boolean) {

    }

    @bind("action")
    onValueChanged(value: TValue) {

    }

    @bind("action")
    executeAsync() {

    }

    getValueText(value: TValue) {
        return this.items?.find(a => a.value == value)?.text ?? "";
    }

    disabled: boolean;

    active: boolean;

    type: "toggle" | "push" | "drop-down";

    items: IButtonOption<TValue>[];

    value: TValue;

    showValue: boolean;

    checked: boolean;

    @bind("action")
    content: (value: TValue, checked?: boolean) => ViewNode;

    menu: ContextMenu;
}
